<template>
    <main id="app" :class="classes">
        <div id="page-status-update-el" class="sr-only" role="status"/>
        <router-view/>
    </main>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      is_safari: null,
    };
  },
  created() {
    this.checkBrowser();
  },
  computed: {
    classes() {
      return {
        'simple-animations': this.is_safari,
      };
    },
  },
  methods: {
    checkBrowser() {
      const userAgent = window.navigator.userAgent.toLowerCase();

      if (userAgent.indexOf('safari') > -1) {
        if (userAgent.indexOf('chrome') > -1) { return; }
        this.is_safari = true;
      }
    },
  },
};
</script>


<style lang="scss">
@import '~@/assets/styles/app.scss';

.copyright {
  position: relative;
  text-align: center;
  width: 100%;
  padding: 20px 0;

  p {
    font-size: 14px;
    margin: 0;
  }

  a {
    color: white;
  }

  span {
    color: white;
  }
}

.custom-select {
  background-color: rgba($color: #000000, $alpha: .6);
}
</style>
